<template>
  <v-container fill-height pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <span class="hidden-sm-and-up">Welcome, {{ username }}</span>
          <v-spacer></v-spacer>
          <span>{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>
        <template>
          <v-flex my-5>
            <v-layout column>
              <v-card-title>
                Reports
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="reportSearch"
                  append-icon="search"
                  label="Search Reports"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="reportsHeaders"
                :items="reports"
                :expand="expand"
                :search="reportSearch"
                item-key="id"
              >
                <template slot="items" slot-scope="props">
                  <tr @click="props.expanded = !props.expanded">
                    <td>{{ props.item.terminal_uuid }}</td>
                    <td>{{ props.item.merchant_name }}</td>
                    <td>{{ props.item.merchant_address }}</td>
                    <td>{{ convertUTCTime(props.item.created) }}</td>
                  </tr>
                </template>
                <template slot="expand" slot-scope="props">
                  <v-card flat>
                        <v-card-text class="grey lighten-3">
                          <v-layout column>
                            <v-flex>
                              <v-layout row wrap>
                                <div class="mx-4 text-xs-center mb-5">
                                  <h3>Comment</h3>
                                  <h2 class="font-weight-light" v-text="props.item.comment"></h2>
                                </div>
                                <div class="mx-4 text-xs-center mb-5">
                                  <h3>Remark</h3>
                                  <h2 class="font-weight-light" v-text="props.item.remark"></h2>
                                </div>
                                <div
                                  class="mx-4 text-xs-center mb-5"
                                  v-if="props.item.further_remark"
                                >
                                  <h3>Further Remark</h3>
                                  <h2
                                    class="font-weight-light"
                                    v-text="props.item.further_remark"
                                  ></h2>
                                </div>
                                <div class="mx-4 text-xs-center mb-5">
                                  <h3>Ref No.</h3>
                                  <h2 class="font-weight-light" v-text="props.item.tx_ref"></h2>
                                </div>
                                <div class="mx-4 text-xs-center mb-5">
                                  <h3>Amount</h3>
                                  <h2 class="font-weight-light" v-text="props.item.tx_amount"></h2>
                                </div>
                                <div
                                  v-if="props.item.emergency_visit"
                                  class="mx-4 text-xs-center mb-5"
                                >
                                  <h3>Emergency</h3>
                                  <h2
                                    class="font-weight-light"
                                    v-text="props.item.emergency_visit"
                                  ></h2>
                                </div>
                                <div class="mx-4 mb-5 text-xs-center">
                                  <h3>Data Providers</h3>
                                  <h2
                                    class="font-weight-light"
                                    v-text="props.item.data_providers"
                                  ></h2>
                                </div>
                                <div class="mx-4 mb-5 text-xs-center">
                                  <h3>Item</h3>
                                  <h2 class="font-weight-light" v-text="props.item.item_name"></h2>
                                </div>
                                <div class="text-xs-center mb-5">
                                  <h3>Qty</h3>
                                  <h2 class="font-weight-light" v-text="props.item.item_quantity"></h2>
                                </div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                </template>
              </v-data-table>
            </v-layout>
          </v-flex>
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import AppLayout from "../../layouts/app"
import utils from "@/common/utils"
import { debounce } from "lodash"
import { mapState, mapGetters, mapActions } from "vuex"
import { DOWNLOAD_MARSHAL_REPORT } from "@/store/actions/ptspAdmin"

export default {
  name: "MarshalReport",
  data() {
    return {
      getDate: new Date(),
      loading: false,
      expand: false,
      reportSearch: "",
      reportsHeaders: [
        {text: "TID", align: "left", value: "terminal_uuid"},
        {text: "Name", value: "merchant_name"},
        {text: "Address", value: "merchant_address"},
        {text: "Date", value: "created"},
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
    }
  },
  computed: {
    ...mapState({
      merchantLocations: state => state.merchant.merchantLocations,
      count: state => state.merchant.merchantLocationsCount,
      reports: state => state.admin.rmReports
    }),
  },
  methods: {
    convertUTCTime(utcTime) {
      if (utcTime) return utils.convertUTCTime(utcTime)
    },
  },
  created() {
    this.$emit("update:layout", AppLayout)
  },
  mounted() {
    const m = new Date()
    const n = new Date()
    m.setDate(1)
    m.setMonth(1)
    m.setHours(1)
    // n.setDate(m.getMonth() + 1)
    this.$store.dispatch(DOWNLOAD_MARSHAL_REPORT, {
      // rm_id: this.$route.params.id,
      date_from: m.toISOString(),
      date_to: n.toISOString(),
      report_type: null,
    })
  }
}
</script>

<style>
.merchant-header {
  background: rgba(0, 0, 0, 0.1)
}
table.v-table thead td:not(:nth-child(1)),
table.v-table tbody td:not(:nth-child(1)),
table.v-table thead th:not(:nth-child(1)),
table.v-table tbody th:not(:nth-child(1)),
table.v-table thead td:first-child,
table.v-table tbody td:first-child,
table.v-table tbody th:first-child {
  padding: 10px !important
}
.pointer {
  cursor: pointer
}
</style>

